import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {ConfigService} from "../config/config.service";
import {Fornecedor} from "../types/Fornecedor.type";

@Injectable({
  providedIn: 'root'
})
export class FornecedorService {

  constructor(private httpClient: HttpClient, private configService: ConfigService) { }

  getFornecedor(codigo: string){
    return this.httpClient.get<Fornecedor>(`${this.configService.getApiUrlIntegrador()}/fornecedor/${codigo}`);
  }

  getFornecedores(){
    return this.httpClient.get<Fornecedor[]>(`${this.configService.getApiUrlRoot()}/fornecedores/`)
  }

  exportar(){
    return this.httpClient.get(`${this.configService.getApiUrlRoot()}/fornecedores/relatorios/exportar`, { responseType: 'blob'})
  }

  getFornecedorSimplificado(codigo: string){
    return this.httpClient.get<Fornecedor>(`${this.configService.getApiUrlRoot()}/fornecedores/simplificado/${codigo}`);
  }
}
